import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    // @ts-ignore
    if (window.fbq) return;
    // @ts-ignore
    window.fbq = function () {
      // @ts-ignore
      window.fbq.callMethod ?
      // @ts-ignore
      window.fbq.callMethod.apply(window.fbq, arguments) :
      // @ts-ignore
      window.fbq.queue.push(arguments);
    };
    // @ts-ignore
    if (!window._fbq) window._fbq = window.fbq;
    // @ts-ignore
    window.fbq.push = window.fbq;
    // @ts-ignore
    window.fbq.loaded = !0;
    // @ts-ignore
    window.fbq.version = '2.0';
    // @ts-ignore
    window.fbq.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // @ts-ignore
    fbq('init', '929826529816985');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  return <div dangerouslySetInnerHTML={{
    __html: `
          <noscript>
            <img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=929826529816985&ev=PageView&noscript=1"
            />
          </noscript>
        `
  }} data-id="element-111" />;
}